import {Copy} from "./Copy";
import {DefaultCopy} from "./DefaultCopy";

export const SquareOneCopy: Copy = {
    start: {
        header: DefaultCopy.start.header,
        id: DefaultCopy.start.id,
        selfie: DefaultCopy.start.selfie
    }
}